
import { defineComponent, PropType, provide, ref, toRef } from 'vue'
import { CmdyClass as CmdyType } from '@/types/cmdyType'
import FavoriteButton from '@/components/common/FavoriteButton.vue'
import { unescapeHTML } from '@/utils/utils'
import productStore from '@/composition/productStore'
import moment from 'moment'
import { COLOR_TYPE, PromotionProductType } from '@/types/PromotionType'

export default defineComponent({
  emits: ['addToCollect'],
  props: {
    // product: {
    //   type: [],
    //   required: false,
    //   default: {
    //     CmdyClassId: '319dbb68-5a7c-11ed-a1ff-0242ac1b0002',
    //     Name: '123',
    //     ShopHallCode: 'BT21',
    //     Rank: 1,
    //     Image: {
    //       PcWeb: 'https://fakeimg.pl/594x399/?text=2',
    //       MobileWeb: 'https://fakeimg.pl/594x399/?text=2'
    //     },
    //     Alternation: '',
    //     MarkImage: '',
    //     ClassDesc: '',
    //     IconImage: 'https://fakeimg.pl/594x399/?text=2'
    //   }
    // }
    product: {
      type: Object as () => CmdyType,
      required: false
    },
    // 販促強調顏色
    promotionHighlight: {
      type: String,
      default: '',
      validator:
        (value: string) => Object.values(COLOR_TYPE).includes(value as COLOR_TYPE) || value === ''
    },
    // 目前販促商品
    currentPromotions: {
      type: Object as PropType<PromotionProductType>,
      default: {
        activeColor: COLOR_TYPE.red,
        colors: {
          red: [],
          green: [],
          blue: []
        }
      } as PromotionProductType
    }
  },
  components: {
    FavoriteButton
  },
  setup (props) {
    provide('productStore', productStore)
    const productRef = toRef(props, 'product')
    const isLike = ref(false)
    const addToCollect = async (item: any) => {
      console.log(item)
      if (!item.IsInCmdyCollect) {
        productStore.addCmdyCollect(item.CmdyId).then((res) => {
          item.IsInCmdyCollect = true
          item.CmdyCollectId = res.collectId
        })
        // try {
        //   const _confirmModal = confirmModal.value as ConfirmModal
        //   _confirmModal
        //     .createConfirm('確定移至我的最愛，下次再訂購？', '', false)
        //     .then(() => {

        //     })
        // } catch (err) {
        //   console.log(err)
        // }
      } else {
        const collectIdArray: string[] = []
        collectIdArray.push(item.CmdyCollectId)
        productStore.delCmdyCollect(collectIdArray).then(() => {
          item.IsInCmdyCollect = false
        })
        // try {
        //   const _confirmModal = confirmModal.value as ConfirmModal
        //   _confirmModal
        //     .createConfirm('確定要從我的最愛移除？', '', false)
        //     .then(() => {
        //     })
        // } catch (err) {
        //   console.log(err)
        // }
      }
    }
    // 檢查該商品是否存在於已選的販促商品，處理特殊樣式
    const existsSelectedPromotion = (_id: string) => {
      if (props.promotionHighlight) {
        return props.currentPromotions.colors[props.promotionHighlight as COLOR_TYPE]
          .some(item => item.id === _id)
      } else {
        return false
      }
    }
    // 若 existsSelectedPromotion 為 true，則可取得該商品已加入於購物車的數量
    const getPromotionQty = (_id: string) => {
      if (existsSelectedPromotion(_id)) {
        return props.currentPromotions.colors[props.promotionHighlight as COLOR_TYPE]
          .filter(item => item.id === _id)[0].qty
      } else {
        return 0
      }
    }
    return {
      isLike,
      productRef,
      addToCollect,
      existsSelectedPromotion,
      getPromotionQty,
      unescapeHTML,
      moment
    }
  }
})
